module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-cup mr-5"
  }), _vm._v(" Welkom " + _vm._s(_vm.user.username) + "!\n  ")]), _vm._v(" "), (_vm.user.role === 'admin') ? _c('admin-dashboard') : _vm._e(), _vm._v(" "), (_vm.user.role === 'orderpicker') ? _c('order-picker-dashboard') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f08dba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/DashboardPage.vue
// module id = 716
// module chunks = 1